import React, { useState } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import api from '../api/axios';
import Badge from '../components/shared/Badge';
import Pagination from '../components/shared/Pagination';
import { format } from 'date-fns';

export default function Archive() {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState('');
  const [clientId, setClientId] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const { data: clients = [] } = useQuery({ queryKey: ['clients'], queryFn: () => api.get('/clients').then(r => r.data) });

  const { data, isLoading } = useQuery({
    queryKey: ['archived', page, perPage, search, clientId, dateFrom, dateTo],
    queryFn: () => api.get('/jobs/archived', { params: {
      search, client_id: clientId, date_from: dateFrom, date_to: dateTo,
      page, per_page: perPage
    }}).then(r => r.data),
    placeholderData: keepPreviousData,
  });

  const jobs = data?.data || [];
  const total = data?.total || 0;

  return (
    <div>
      <div style={{ background: '#f1f3f5', border: '1px solid #e9ecef', borderRadius: 7, padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, fontSize: 12, color: '#6c757d' }}>
        <div><strong style={{ color: '#343a40' }}>Archived Jobs</strong> — Completed jobs auto-archive after 7 days. Read-only; excluded from active job counts.</div>
      </div>

      <div style={{ background: '#fff', border: '1px solid #e9ecef', borderRadius: 8, padding: '10px 13px', display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap', marginBottom: 12 }}>
        <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }}
          placeholder="Search archived jobs…"
          style={{ flex: 1, minWidth: 150, padding: '5px 9px', border: '1px solid #ced4da', borderRadius: 5, fontSize: 12 }} />
        <select value={clientId} onChange={e => { setClientId(e.target.value); setPage(1); }}
          style={{ padding: '5px 8px', border: '1px solid #ced4da', borderRadius: 5, fontSize: 12 }}>
          <option value="">All Clients</option>
          {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <input type="date" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setPage(1); }}
            style={{ padding: '5px 8px', border: '1px solid #ced4da', borderRadius: 5, fontSize: 12, width: 130 }} />
          <span style={{ fontSize: 11, color: '#6c757d' }}>to</span>
          <input type="date" value={dateTo} onChange={e => { setDateTo(e.target.value); setPage(1); }}
            style={{ padding: '5px 8px', border: '1px solid #ced4da', borderRadius: 5, fontSize: 12, width: 130 }} />
        </div>
      </div>

      <div className="tbl-wrap">
        <div className="tbl-head-row">
          <span style={{ fontSize: 13, fontWeight: 600, color: '#343a40' }}>
            Archived Jobs <span style={{ fontWeight: 400, fontSize: 11, color: '#6c757d' }}>({total} records)</span>
          </span>
        </div>
        <div className="tbl-scroll">
          <table>
            <thead>
              <tr>
                <th>Job No</th><th>Date</th><th>Client</th><th>Project Name</th>
                <th>Category</th><th>Completed On</th><th>Designer</th>
                <th>Mode</th><th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr><td colSpan={9} style={{ textAlign: 'center', padding: 30, color: '#6c757d' }}>Loading…</td></tr>
              ) : jobs.length === 0 ? (
                <tr><td colSpan={9} style={{ textAlign: 'center', padding: 40, color: '#6c757d' }}>No archived jobs yet.</td></tr>
              ) : jobs.map(j => (
                <tr key={j.id}>
                  <td><span style={{ fontWeight: 700, color: '#6c757d', fontFamily: 'monospace', fontSize: 11 }}>{j.job_no}</span></td>
                  <td style={{ color: '#6c757d', fontSize: 11, whiteSpace: 'nowrap' }}>{j.created_at ? format(new Date(j.created_at), 'dd MMM yyyy') : '—'}</td>
                  <td><strong>{j.client_name}</strong></td>
                  <td style={{ maxWidth: 140, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{j.project_name}</td>
                  <td><span style={{ fontSize: 10, background: '#f1f3f5', padding: '2px 7px', borderRadius: 10, color: '#6c757d' }}>{j.category_name}</span></td>
                  <td style={{ color: '#037b3e', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>
                    {j.completed_at ? format(new Date(j.completed_at), 'dd MMM yyyy') : '—'}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>{j.designer_name || '—'}</td>
                  <td><Badge type="mode" value={j.mode} /></td>
                  <td style={{ color: '#6c757d', fontSize: 11 }}>{j.invoice_no || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          page={page} totalPages={Math.max(1, Math.ceil(total / perPage))}
          total={total} perPage={perPage}
          onPageChange={setPage}
          onPerPageChange={n => { setPerPage(n); setPage(1); }}
        />
      </div>
    </div>
  );
}
